<script setup>
import ModalLayout from "@/components/modals/Layouts/ModalLayout.vue";
</script>

<template>
  <ModalLayout>
    <template #header>
      <h2>Згода на обробку персональних даних</h2>
    </template>

    <p>Дозвольте зберігання та обробку персональних даних.</p>
    <p>Ми не передаємо персональні дані Користувача третім особам крім випадків визначених законодавством України.</p>
  </ModalLayout>
</template>
